<template>
  <div class="vx-row">
    <div class="vx-col  xl:w-1/2  w-full mb-base">
      <form v-on:submit.prevent="updatePersonalDetails">
        <vx-card title="Persoonlijke gegevens">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <span
                class="input-span-placeholder normal normal vs-placeholder-label"
                style="position:initial; font-size: .7rem; color: rgba(0,0,0,.4);"
              >
                Klantnummer
              </span>
              <ul class="centerx">
                <li class="mb-4">
                  <span>
                    {{ customer.customer_id }}
                  </span>
                </li>
              </ul>
              <span
                class="input-span-placeholder normal normal vs-placeholder-label"
                style="position:initial; font-size: .7rem; color: rgba(0,0,0,.4)"
              >
                Aanhef
              </span>
              <ul class="centerx">
                <li>
                  <vs-radio v-model="customer.gender" vs-value="1"
                    >Dhr.</vs-radio
                  >
                </li>
                <li>
                  <vs-radio v-model="customer.gender" vs-value="2"
                    >Mevr.</vs-radio
                  >
                </li>
              </ul>
              <span
                class="text-danger text-sm"
                v-if="errors['request.Gender']"
                >{{ errors["request.Gender"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full lg:w-1/3">
              <vs-input
                class="w-full"
                label-placeholder="Voorletters"
                v-model="customer.initials"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.Initials']"
                >{{ errors["request.Initials"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/3  mb-2">
              <vs-input
                class="w-full"
                label-placeholder="Voornaam"
                v-model="customer.nickname"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.Nickname']"
                >{{ errors["request.Nickname"][0] }}</span
              >
            </div>
            <div class="vx-col w-full lg:w-1/3  mb-2">
              <vs-input
                class="w-full"
                label-placeholder="Tussenvoegsel"
                v-model="customer.last_name_prefix"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.LastNamePrefix']"
                >{{ errors["request.LastNamePrefix"][0] }}</span
              >
            </div>
            <div class="vx-col w-full lg:w-1/3  mb-2">
              <vs-input
                class="w-full"
                label-placeholder="Achternaam"
                v-model="customer.last_name"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.LastName']"
                >{{ errors["request.LastName"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <datepicker
                placeholder="Select Date"
                v-model="dateOfBirth"
                :format="customFormatter"
              ></datepicker>
              <span
                class="text-danger text-sm"
                v-if="errors['request.BirthDate']"
                >{{ errors["request.BirthDate"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full mb-2 mt-base">
              <h5>Contactgegevens</h5>
            </div>
            <div class="vx-col w-full lg:w-1/3 mb-2">
              <vs-input
                class="w-full"
                type="email"
                label-placeholder="Email"
                v-model="customer.email_adress"
              />
              <span
                class="text-warning text-sm"
                v-if="
                  $store.state.customer.email_adress != customer.email_adress
                "
                >Het aanpassen van je e-mail zorgt ervoor dat ook je
                gebruikersnaam verandert. Houd hier dus rekening mee als je de
                volgende keer wilt inloggen in Mijn Naked Energy.</span
              >
              <span
                class="text-danger text-sm"
                v-if="errors['request.EmailAdress']"
                >{{ errors["request.EmailAdress"][0] }}</span
              >
            </div>

            <div class="vx-col w-full lg:w-1/3">
              <vs-input
                class="w-full"
                label-placeholder="Telefoonnummer"
                v-model="customer.phonenumber"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.EmailAdress']"
                >{{ errors["request.EmailAdress"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full mb-2 mt-base">
              <h5>Bedrijfsgegevens</h5>
            </div>
            <div class="vx-col w-full lg:w-1/3">
              <vs-input
                class="w-full"
                label-placeholder="Bedrijfsnaam"
                v-model="customer.company_name"
              />
              <span
                class="text-danger text-sm"
                v-if="errors['request.CompanyName']"
                >{{ errors["request.CompanyName"][0] }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-button
                color="success"
                type="filled"
                button="submit"
                v-if="!loading && !success"
                >{{ $t("modify") }}</vs-button
              >

              <div class="vx-col" v-if="success">
                <vs-alert color="success" title="Verstuurd" active="true">
                  We hebben je verzoek binnengekregen om je gegevens aan te
                  passen. Je ontvangt bericht wanneer het daadwerkelijk is
                  aangepast.
                </vs-alert>
              </div>
              <pulse-loader :loading="loading"></pulse-loader>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import Datepicker from "vuejs-datepicker";
import axios from "@/axios";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      customer: {},
      errors: {},
      success: false
    };
  },
  components: { Datepicker, PulseLoader },
  methods: {
    customFormatter(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    async getCustomer() {
      try {
        let res = await axios().get("/api/customer");
        this.customer = res.data;
      } catch (err) {
        this.showError(
          "Je persoonlijke gegevens kunnen op het moment niet opgehaald worden",
          false,
          err
        );
      }
    },
    async updatePersonalDetails() {
      this.loading = true;
      try {
        await axios().post("/api/customer", this.customer);
        this.success = true;
      } catch (e) {
        this.errors = e.response.data.errors;
      }
      this.loading = false;
    }
  },
  created() {
    this.getCustomer();
  },
  computed: {
    dateOfBirth: {
      get() {
        return this.customer.birth_date;
      },
      set(value) {
        this.customer.birth_date = moment(value).format("YYYY-MM-DD");
      }
    }
  }
};
</script>

<style></style>
